import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Input } from "../../components/commons";
import { IconArrowRight } from "../../assests/icons";

const EditAsset = (props) => {
  const { asset, onBack, onSave } = props;
  const { t } = useTranslation();
  const initialData = {
    name: "",
  };

  const [assetData, setAssetData] = useState(initialData);
  const [isAssetFormSubmitted, setIsAssetFormSubmitted] = useState(false);

  useEffect(() => {
    if (asset) {
      setAssetData(asset);
    }
  }, [asset]);

  const handleChangeAssetData = (filed, value) =>
    setAssetData({ ...assetData, [filed]: value });

  const handleCreateAsset = () => {
    setIsAssetFormSubmitted(true);

    if (!assetData.name) {
      return;
    }

    const body = {
      ...assetData,
    };

    onSave(body);
  };

  return (
    <div className="edit-page">
      <div className="header">
        <span role="button" className="back-button" onClick={() => onBack()}>
          <IconArrowRight />
        </span>
        {asset ? (
          <span className="title">Edit {asset.name}</span>
        ) : (
          <span className="title">Add New Asset</span>
        )}
      </div>
      <div className="detail-form">
        <Input
          className="master-data-modal__input"
          size="lg"
          required
          isCheckValid={isAssetFormSubmitted}
          label={t("master_data.name_label")}
          value={assetData.name ?? ""}
          onChange={(e) => handleChangeAssetData("name", e)}
        />
      </div>
      <div>
        <Button
          className="save-button"
          size="md40"
          variant="success"
          onClick={handleCreateAsset}
          text={t("master_data.save_button")}
        />
      </div>
    </div>
  );
};
export default EditAsset;
